import { computed } from 'vue';
import { useMapGetter } from './store';

// O nome que o escritório deu ao seu agente (10/10/2026 — a A&T escolheu
// "Andie"). A regra mora no servidor (Lumos::NomeDoAgente: escolha do
// escritório → roteador → "Assistente") e chega pronta na conta; a tela só lê.
// Nunca escrever "Andie" num componente.
//
// Pela loja e não pela rota: cartões da lista e testes montam sem roteador.
export const NOME_PADRAO = 'Assistente';

export function nomeDoAgenteDa(conta) {
  return conta?.nome_do_agente || NOME_PADRAO;
}

export function useNomeDoAgente() {
  const contaAtualId = useMapGetter('getCurrentAccountId');
  const contaPorId = useMapGetter('accounts/getAccount');
  // Tolerante: getter ausente (loja parcial em teste, tela pública) cai no
  // padrão em vez de derrubar o componente.
  const conta = computed(() =>
    typeof contaPorId.value === 'function'
      ? contaPorId.value(contaAtualId.value)
      : undefined
  );
  const nomeDoAgente = computed(() => nomeDoAgenteDa(conta.value));
  const masculino = computed(
    () => conta.value?.genero_do_agente === 'masculino'
  );
  return { nomeDoAgente, masculino };
}
